import AlreadyRegisteredPage from './AlreadyRegisteredPage';
import { AlreadyRegisteredPageProps, AlreadyRegisteredPageValueProps } from './types';

export type { AlreadyRegisteredPageProps, AlreadyRegisteredPageValueProps };
export default AlreadyRegisteredPage;
